(function() {
  var qtyIsUpdating = false;
  var qtyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root : '/';

  function qtyFormatMoney(cents, currency) {
    if (typeof cents !== 'number') return '';
    var cur = String(currency || 'PEN').toUpperCase();
    var val = Number(cents / 100);
    if (cur === 'PEN') {
      return 'S/. ' + val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return val.toLocaleString('en-US', { style: 'currency', currency: cur, minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function qtyUpdateTotals(data) {
    if (!data) return;

    var cartForm = document.getElementById('cart');
    if (!cartForm) return;

    var itemsMap = {};
    if (data.items) {
      data.items.forEach(function(item) {
        itemsMap[item.key] = item;
      });
    }

    var rows = cartForm.querySelectorAll('.tw-cart-item');
    rows.forEach(function(row) {
      var input = row.querySelector('.tw-cart-qty__input');
      if (!input) return;
      var key = input.getAttribute('data-key');
      var item = key ? itemsMap[key] : null;
      if (!item) return;

      input.value = item.quantity;

      var totalCell = row.querySelector('.tw-cart-item__total');
      if (totalCell) {
        if (item.original_line_price !== item.final_line_price) {
          totalCell.innerHTML =
            '<s class="tw-cart-item__original">' + qtyFormatMoney(item.original_line_price, data.currency) + '</s> ' +
            '<strong>' + qtyFormatMoney(item.final_line_price, data.currency) + '</strong>';
        } else {
          totalCell.innerHTML = qtyFormatMoney(item.original_line_price, data.currency);
        }
      }

      var priceCell = row.querySelector('.tw-cart-item__price .tw-cart-item__price-wrapper');
      if (priceCell) {
        if (item.original_price !== item.final_price) {
          priceCell.innerHTML =
            '<s class="tw-cart-item__original">' + qtyFormatMoney(item.original_price, data.currency) + '</s> ' +
            '<strong>' + qtyFormatMoney(item.final_price, data.currency) + '</strong>';
        } else {
          priceCell.innerHTML = qtyFormatMoney(item.original_price, data.currency);
        }
      }

      var discountList = row.querySelector('.tw-cart-item__discounts');
      if (discountList) {
        if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
          discountList.innerHTML = item.line_level_discount_allocations.map(function(d) {
            return '<li>' + d.discount_application.title + ' (-' + qtyFormatMoney(d.amount, data.currency) + ')</li>';
          }).join('');
          discountList.style.display = '';
        } else {
          discountList.style.display = 'none';
        }
      }
    });

    var twMain = document.querySelector('.tw-main-cart');
    if (twMain) {
      var subtotalEl = twMain.querySelector('.tw-main-cart__subtotal strong');
      if (subtotalEl) {
        subtotalEl.textContent = qtyFormatMoney(data.total_price, data.currency);
      }

      var discountListEl = twMain.querySelector('.tw-main-cart__discounts-list');
      if (discountListEl) {
        var apps = data.cart_level_discount_applications || [];
        if (apps.length > 0) {
          discountListEl.innerHTML = apps.map(function(d) {
            return '<li><span>' + d.title + '</span> <span>-' + qtyFormatMoney(d.total_allocated_amount, data.currency) + '</span></li>';
          }).join('');
          discountListEl.style.display = '';
        } else {
          discountListEl.style.display = 'none';
        }
      }
    }

    var minOrder = document.querySelector('[data-cart-minimum-order]');
    if (minOrder) {
      var minCents = parseInt(minOrder.getAttribute('data-cart-minimum-cents'), 10) || 0;
      var msgEl = minOrder.querySelector('.tw-main-cart__minimum-order-msg');
      if (msgEl) {
        if (data.items_subtotal_price >= minCents) {
          msgEl.textContent = 'Ya alcanzaste el m\u00ednimo de compra.';
        } else {
          var remaining = minCents - data.items_subtotal_price;
          msgEl.innerHTML = 'Te faltan <strong>' + qtyFormatMoney(remaining, data.currency) + '</strong> para alcanzar el m\u00ednimo de compra.';
        }
      }
      var checkoutBtn = document.querySelector('button[name="checkout"][form="cart"]');
      if (checkoutBtn) {
        var canCheckout = data.items_subtotal_price >= minCents;
        checkoutBtn.disabled = !canCheckout;
        if (canCheckout) {
          checkoutBtn.removeAttribute('aria-disabled');
          checkoutBtn.classList.remove('tw-opacity-50', 'tw-cursor-not-allowed');
        } else {
          checkoutBtn.setAttribute('aria-disabled', 'true');
          checkoutBtn.classList.add('tw-opacity-50', 'tw-cursor-not-allowed');
        }
      }
    }

    var shippingBar = document.querySelector('[data-cart-page-shipping-bar]');
    if (shippingBar) {
      var shippingMsg = shippingBar.querySelector('[data-cart-page-shipping-msg]');
      var shippingProgress = shippingBar.querySelector('[data-cart-page-shipping-progress]');
      if (shippingMsg && shippingProgress) {
        var fsMinimum = parseInt(shippingBar.getAttribute('data-fs-minimum'), 10) || 0;
        if (fsMinimum > 0) {
          var subtotal = data.items_subtotal_price;
          var remaining = fsMinimum - subtotal;
          var percent = Math.min(100, Math.max(0, subtotal * 100 / fsMinimum));
          var achieved = subtotal >= fsMinimum;
          shippingProgress.style.width = percent + '%';
          shippingProgress.classList.toggle('tw-main-cart__shipping-progress--done', achieved);
          if (achieved) {
            shippingMsg.innerHTML = '\u00a1Felicidades! Tienes env\u00edo gratis.';
          } else {
            shippingMsg.innerHTML = 'Agrega <strong>' + qtyFormatMoney(remaining, data.currency) + '</strong> m\u00e1s para env\u00edo gratis.';
          }
        }
      }
    }

    var cartCountEls = document.querySelectorAll('[data-cart-count]');
    cartCountEls.forEach(function(el) {
      el.textContent = data.item_count;
      el.style.display = data.item_count > 0 ? 'flex' : 'none';
    });
  }

  function qtyChange(key, quantity, inputEl) {
    if (!key || qtyIsUpdating) return;
    qtyIsUpdating = true;

    var wrapper = inputEl ? inputEl.closest('.tw-cart-qty') : null;
    if (wrapper) wrapper.classList.add('is-loading');

    document.querySelectorAll('.tw-cart-qty__btn, .tw-cart-qty__input').forEach(function(el) {
      el.disabled = true;
    });

    fetch(qtyRoot + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function(res) {
        if (!res.ok) {
          return res.json().then(function(err) {
            throw new Error(err.description || err.message || 'No se pudo actualizar el carrito.');
          });
        }
        return res.json();
      })
      .then(function(data) {
        qtyUpdateTotals(data);
        if (wrapper) wrapper.classList.remove('is-loading');
        document.querySelectorAll('.tw-cart-qty__btn, .tw-cart-qty__input').forEach(function(el) {
          el.disabled = false;
        });
        qtyIsUpdating = false;
      })
      .catch(function(error) {
        console.error('[Cart quantity]', error);
        var msg = error.message || 'No se pudo actualizar la cantidad del producto.';
        var errorEl = inputEl ? inputEl.closest('.tw-cart-item') : null;
        if (errorEl) {
          var existing = errorEl.querySelector('.tw-cart-item__qty-error');
          if (!existing) {
            var p = document.createElement('p');
            p.className = 'tw-cart-item__qty-error';
            p.style.cssText = 'font-size:0.75rem;color:#b91c1c;margin:0.25rem 0 0;';
            p.textContent = msg;
            var qtyCell = errorEl.querySelector('.tw-cart-item__quantity');
            if (qtyCell) qtyCell.appendChild(p);
          }
        } else {
          alert(msg);
        }
        if (wrapper) wrapper.classList.remove('is-loading');
        document.querySelectorAll('.tw-cart-qty__btn, .tw-cart-qty__input').forEach(function(el) {
          el.disabled = false;
        });
        qtyIsUpdating = false;
      });
  }

  function qtyClickHandler(event) {
    var button = event.target.closest(
      '.tw-cart-qty__btn[data-action="plus"], ' +
      '.tw-cart-qty__btn[data-action="minus"]'
    );
    if (!button) return;

    var wrapper = button.closest('.tw-cart-qty');
    if (!wrapper) return;

    var input = wrapper.querySelector('.tw-cart-qty__input');
    if (!input) return;

    var currentQty = parseInt(input.value, 10);
    if (Number.isNaN(currentQty)) currentQty = 0;

    var action = button.getAttribute('data-action');
    var newQty = action === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);

    input.value = newQty;

    var key = input.getAttribute('data-key');
    qtyChange(key, newQty, input);
  }

  function qtyChangeHandler(event) {
    var input = event.target.closest('.tw-cart-qty__input');
    if (!input) return;

    var qty = parseInt(input.value, 10);
    if (Number.isNaN(qty) || qty < 0) {
      qty = 0;
      input.value = qty;
    }

    var key = input.getAttribute('data-key');
    qtyChange(key, qty, input);
  }

  function initCartQuantity() {
    document.removeEventListener('click', qtyClickHandler);
    document.removeEventListener('change', qtyChangeHandler);
    document.addEventListener('click', qtyClickHandler);
    document.addEventListener('change', qtyChangeHandler);
  }

  initCartQuantity();

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && (e.target.id === 'main-cart-items' || (e.target.querySelector && e.target.querySelector('#main-cart-items')))) {
      initCartQuantity();
    }
  });
})();
